import { cn } from '@/utils/classnames';

import { CloseIcon } from '../icons/close';
import { Button } from './button';
import { Typography } from './typography';

interface TagProps {
  className?: string;
  textClassName?: string;
  icon?: React.ReactNode | string;
  text?: React.ReactNode;
  onClose?: () => void;
}

export function Tag({
  className,
  textClassName,
  icon,
  text,
  onClose,
}: TagProps) {
  return (
    <div
      className={cn(
        'flex h-6 w-fit items-center justify-center gap-1 whitespace-nowrap rounded-full px-2',
        className,
      )}
    >
      {icon && typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
      {text && (
        <Typography
        variant="small1"
        className={cn('text-fx-neutral-600 px-1', textClassName)}
      >
        {text}
      </Typography>
      )}
      {onClose && (
        <Button
          variant="ghost"
          className="h-auto !p-0 hover:bg-transparent"
          onClick={onClose}
        >
          <CloseIcon className={cn('text-fx-neutral-600', textClassName)} />
        </Button>
      )}
    </div>
  );
}
